import { buildQuery, requestJson } from "./apiClient";

export function listFavoriteListings(params = {}) {
  return requestJson(`/api/account/favorites/listings${buildQuery(params)}`);
}

export function addFavoriteListing(payload) {
  return requestJson("/api/account/favorites/listings", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function removeFavoriteListing(favoriteListingId) {
  return requestJson(`/api/account/favorites/listings/${favoriteListingId}`, {
    method: "DELETE",
  });
}

export function removeFavoriteByRef(payload) {
  return requestJson("/api/account/favorites/listings/by-ref", {
    method: "DELETE",
    body: JSON.stringify(payload),
  });
}

export function checkFavoriteListing(params = {}) {
  return requestJson(`/api/account/favorites/listings/check${buildQuery(params)}`);
}
